var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LoginActionButton',{attrs:{"action":_vm.submit,"isLoading":_vm.isLoading,"disabled":_vm.isLoading,"type":"submit"}},[_vm._v("\n  "+_vm._s(_vm.uiLabel.allow)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }